var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.onHoldHistories.length
    ? _c(
        "div",
        [
          _c("p", { staticClass: "history-title" }, [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.$t("tenantProjects.greenFitOut.onHoldHistoryTitle")
                ) +
                "\n  "
            ),
          ]),
          _vm._v(" "),
          _c("HKLTable", {
            attrs: {
              dataSource: _vm.onHoldHistories,
              columns: _vm.onHoldColumns,
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }